/**
 * The choices on the new-user onboarding form, as the Floto Rooms design has
 * them. Both this form and flotoapps' `/onboarding` write the same
 * `jodb/users/{uid}` fields via the jo service, so where a choice means the
 * same thing as one of flotoapps' its stored value is kept — "Product
 * manager" still saves as `Product Manager`, "A friend or colleague" as
 * `colleague_friend` — and profiles read alike whichever product made them.
 * Only what is genuinely new (Founder, Engineer, Chrome Web Store) is new.
 */
export const ONBOARDING_ROLES = [
  { label: 'Designer', value: 'Designer' },
  { label: 'Product manager', value: 'Product Manager' },
  { label: 'Researcher', value: 'Researcher' },
  { label: 'Founder', value: 'Founder' },
  { label: 'Engineer', value: 'Engineer' },
  { label: 'Student', value: 'Student' },
  { label: 'Other', value: 'Other' },
] as const;

/**
 * Roles this form offered before the redesign. Still accepted, so a browser
 * holding the old page can finish signing up; never offered.
 */
const LEGACY_ROLE_VALUES = ['Developer'] as const;

export type OnboardingRole =
  | (typeof ONBOARDING_ROLES)[number]['value']
  | (typeof LEGACY_ROLE_VALUES)[number];

export const ONBOARDING_ROLE_VALUES: readonly OnboardingRole[] = [
  ...ONBOARDING_ROLES.map((r) => r.value),
  ...LEGACY_ROLE_VALUES,
];

export const ONBOARDING_SOURCES = [
  { label: 'A friend or colleague', value: 'colleague_friend' },
  { label: 'Search engine', value: 'search_engine' },
  { label: 'Instagram', value: 'instagram' },
  { label: 'LinkedIn', value: 'linkedin' },
  { label: 'X', value: 'x' },
  { label: 'Figma Community', value: 'figma_community' },
  { label: 'Chrome Web Store', value: 'chrome_web_store' },
  { label: 'AI chat (ChatGPT, Claude, etc.)', value: 'ai_search_chat' },
  { label: 'YouTube', value: 'youtube' },
  { label: 'Reddit', value: 'reddit' },
  { label: 'Other', value: 'other' },
] as const;

/** Sources the form offered before the redesign — accepted, never offered. */
const LEGACY_SOURCE_VALUES = [
  'reddit',
  'x',
  'ai_search_chat',
  'youtube',
  'instagram',
] as const;

export type OnboardingSource =
  | (typeof ONBOARDING_SOURCES)[number]['value']
  | (typeof LEGACY_SOURCE_VALUES)[number];

export const ONBOARDING_SOURCE_VALUES: readonly OnboardingSource[] = [
  ...ONBOARDING_SOURCES.map((s) => s.value),
  ...LEGACY_SOURCE_VALUES,
];
